import React from 'react';
import { motion } from 'framer-motion';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';

const useStyles = createUseStyles({
	section: {
		paddingTop: '4rem',
		paddingBottom: '5rem',
	},
	panel: {
		position: 'relative',
		paddingTop: '8rem',
		paddingBottom: '8rem',
		paddingLeft: '1.5rem',
		paddingRight: '1.5rem',
		background:
			'radial-gradient(120% 80% at 50% 0%, rgba(13, 202, 240, 0.18) 0%, rgba(13, 202, 240, 0) 60%), var(--bs-gray-200)',
		overflow: 'hidden',
	},
	eyebrow: {
		fontSize: '0.95rem',
		fontWeight: 700,
		letterSpacing: '0.18em',
		textTransform: 'uppercase',
		color: 'var(--bs-info)',
		marginBottom: '1.25rem',
	},
});

const sectionVariants = {
	hidden: { opacity: 0, y: 24 },
	visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
};

const SectionBuyNow = () => {
	const classes = useStyles();
	return (
		<motion.div
			id='integrated'
			className={classNames('row scroll-margin g-4', classes.section)}
			variants={sectionVariants}
			initial='hidden'
			whileInView='visible'
			viewport={{ once: true, amount: 0.2 }}>
			<div className={classNames('col-12 rounded-2 text-center', classes.panel)}>
				<div className={classes.eyebrow}>Ready when you are</div>
				<div className='display-1 fw-bold mb-3'>AI has never been this easy.</div>
				<div className='lead mb-5'>Come and see for yourself.</div>
				<a
					href='https://app.ai4us.net/newModel'
					className='btn btn-info btn-lg px-5 py-3 rounded-1 fw-bold'>
					Build My First Model
				</a>
			</div>
		</motion.div>
	);
};

export default SectionBuyNow;
